import { matchUrlLocalePrefix } from "~/lib/language-lens";

function normalizeInitialPathname(pathname: string): string {
  const locale = matchUrlLocalePrefix(pathname);
  const localeStrippedPathname =
    locale === null
      ? pathname
      : pathname.indexOf("/", 1) === -1
        ? "/"
        : pathname.slice(pathname.indexOf("/", 1));

  if (
    localeStrippedPathname.length > 1 &&
    localeStrippedPathname.endsWith("/")
  ) {
    return localeStrippedPathname.slice(0, -1);
  }

  return localeStrippedPathname;
}

export function isStartInitialPathname(pathname: string): boolean {
  return normalizeInitialPathname(pathname) === "/start";
}

export function isStartRuntimeRequired(
  pathname: string,
  searchStr: string,
): boolean {
  return (
    isStartInitialPathname(pathname) &&
    new URLSearchParams(searchStr).has("step")
  );
}

export function isExploreInitialPathname(pathname: string): boolean {
  return normalizeInitialPathname(pathname) === "/explore";
}

export function isPublicBrowseInitialPathname(pathname: string): boolean {
  // Guest rendering also covers aliases/lowercase symbols. Shared HTML cache
  // eligibility separately requires a validated canonical symbol.
  const normalized = normalizeInitialPathname(pathname);
  return (
    normalized === "/" ||
    normalized === "/start" ||
    normalized === "/explore" ||
    normalized === "/stocks" ||
    normalized === "/currencies" ||
    normalized === "/build" ||
    /^\/stocks\/[^/]+$/u.test(normalized) ||
    /^\/user\/[^/]+$/u.test(normalized)
  );
}

const RWA_MARKETS_INITIAL_PATHNAMES = new Set([
  "/bonds",
  "/commodities",
  "/currencies",
  "/pre-ipo",
  "/private-credit",
]);

export function isRwaMarketsInitialPathname(pathname: string): boolean {
  return RWA_MARKETS_INITIAL_PATHNAMES.has(normalizeInitialPathname(pathname));
}

export function preloadInitialRouteModule(
  pathname: string,
): Promise<unknown> | undefined {
  if (isExploreInitialPathname(pathname)) {
    return import("~/features/explore");
  }

  if (isRwaMarketsInitialPathname(pathname)) {
    return Promise.all([
      import("~/features/rwa-markets/page"),
      import("~/features/rwa-markets/rwa-markets-route"),
    ]);
  }

  return undefined;
}
